<template>
  <div>
    <LocationHeader
      v-if="location && $route.name !== 'LocationEdit'"
      :location="location"
    ></LocationHeader>
    <div
      v-else-if="isLoading && !location"
      style="height: 40vh; width: 100%"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <VueLoader />
      <h2>Loading Location</h2>
    </div>
    <div class="bg-white border-bottom border-top" v-if="location">
      <div class="container py-2">
        <div class="row">
          <div class="location-detail py-1 col-md-6 col-lg-4">
            <div class="font-weight-bold">Project</div>
            <div>
              <b-link
                :to="{
                  name: 'ProjectShow',
                  params: { id: location.project.urlField },
                }"
              >
                {{ location.project.name }}
              </b-link>
              <i class="fa fa-arrow-right mx-2"></i>
              <b-link
                :to="{
                  name: 'ProjectLocations',
                  params: { id: location.project.urlField },
                }"
              >
                Locations
              </b-link>
            </div>
          </div>
          <div class="location-detail py-1 col-md-6 col-lg-3">
            <div class="font-weight-bold">Name</div>
            <div>{{ location.name }}</div>
          </div>
          <div class="location-detail py-1 col-md-6 col-lg-2" v-if='location.lngLat.exact'>
            <div class="font-weight-bold">Exact Coordinates</div>
            <div>
              <span>{{ location.lngLat.exact.lat }}</span> ,
              <span>{{ location.lngLat.exact.lng }}</span>
            </div>
          </div>
          <div class="location-detail py-1 col-md-6 col-lg-3" v-if='location.lngLat.blurred'>
            <div class="font-weight-bold">Blurred Coordinates</div>
            <div>
              <span>{{ location.lngLat.blurred.lat.toString().replace(/(\.\d{7})\d+/, "$1") }}</span> ,
              <span>{{ location.lngLat.blurred.lng.toString().replace(/(\.\d{7})\d+/, "$1") }}</span>
            </div>
          </div>
          <div class="location-detail py-1 col-md-6 col-lg-3" v-else>
            <div class="font-weight-bold">Coordinates</div>
            <div>
              <span>{{ location.lngLat.lat }}</span> ,
              <span>{{ location.lngLat.lng }}</span>
            </div>
          </div>
          <div class="location-detail py-1 col-md-6 col-lg-2">
            <b-link
              class="btn btn-primary btn-block"
              :href="`https://www.google.com/maps/search/?api=1&query=${location.lngLat.lat},${location.lngLat.lng}`"
              target="_blank"
              rel="noopener noreferrer"
              >Directions
            </b-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-3">
      <LocationMessage v-if="message"></LocationMessage>
      <b-card no-body header-tag="nav">
        <template #header>
          <LocationNav></LocationNav>
        </template>
        <router-view v-if="location" class="mt-2"></router-view>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LocationHeader from "./LocationHeader.vue";
import VueLoader from "../layout/Loader";
import LocationMessage from "./LocationMessage.vue";
import LocationNav from "./LocationNav.vue";

export default {
  name: "LocationDetails",
  components: {
    LocationHeader,
    VueLoader,
    LocationMessage,
    LocationNav,
  },

  created() {
    this.fetchLocation(this.$route.params.id);
  },

  computed: {
    ...mapGetters({
      isLoading: "location/isLoading",
      location: "location/details",
      message: "location/message",
    }),
  },
  methods: {
    ...mapActions({
      fetchLocation: "location/fetchLocation",
    }),
  },
};
</script>
<style lang="css" scoped></style>
